import moment from 'moment';

export default {
  state: {
    currentTime: moment().format(),
  },
  mutations: {
    addSecondsToCurrentTime: (state, seconds = 1) => {
      state.currentTime = moment
        .utc(state.currentTime)
        .add(seconds, 'seconds')
        .format();
    },
    setCurrentTime: (state, currentTime) => {
      state.currentTime = currentTime;
    },
  },
  getters: {
    currentTime: state => {
      return state.currentTime;
    },
  },
};
